export default function apiUrl() {
	if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
		return `https://mattfletcher.cpteller.com/cportal/api.cfc`;
	} else {
		console.log('IS PRODUCTION ENVIRONMENT');
		return `https://${window.location.hostname}/cportal/api.cfc`;
	}
}
